import { AbstractControl } from '@angular/forms'

export function npiValidator(control: AbstractControl) {
  const value = control.value
  return typeof value === 'string' && value.length === 10 ? null : { npi: true }
}
